export class LoginMetadata {
  static samlRequestIdKey = 'EP_samlRequestID_key';
  static samlRelayStateKey = 'RelayState';
  static samlResponsePrefixKey = 'SAMLResponse_';
  static samlResponsePartsCountKey = 'SAMLResponsePartsCount';
  static externalSessionIndexKey = 'externalSessionIndex';
  static userContext = 'userContext';
  static activeRole = 'activeRole';
}
